import { FormControl } from "@mui/material";
import { DateTimePicker } from "@mui/x-date-pickers";
import { useEffect } from "react";
import { DATE_TIME_FORMAT } from "../../utils/constants";
import moment, { Moment } from "moment";

interface DateTimeFieldProps extends React.ReactElement {
  fieldKey: string;
  value: Moment | null;
  onChange: (key: string, value: Moment | null) => void;
  placeholder: string;
  disabled: boolean;
  required: boolean;
  helperText: string;
}

const DateTimeField: React.FC<DateTimeFieldProps> = ({
  fieldKey,
  value,
  onChange,
  placeholder,
  disabled,
  required,
}) => {
  useEffect(() => {
    // to set the default value to form
    onChange(fieldKey, value);
  }, [onChange, value, fieldKey]);

  const handleChange = (value: Moment | null) => {
    onChange(fieldKey, value || null);
  };

  return (
    <FormControl required={required} disabled={disabled}>
      <DateTimePicker
        defaultValue={moment()}
        format={DATE_TIME_FORMAT}
        value={value}
        onChange={handleChange}
        slotProps={{
          textField: {
            required: required,
            placeholder: placeholder,
            disabled: disabled,
          },
        }}
      />
    </FormControl>
  );
};

export default DateTimeField;
